export const CHAIN_STRATEGY_VALUES = ["inherit_tail", "canonical", "neutral"];
export const ChainStrategy = {
    INHERIT_TAIL: "inherit_tail",
    CANONICAL: "canonical",
    NEUTRAL: "neutral",
};
export const CHAIN_STRATEGY_LABELS = {
    [ChainStrategy.INHERIT_TAIL]: "Hérite de la frame précédente",
    [ChainStrategy.CANONICAL]: "Keyframe canonique",
    [ChainStrategy.NEUTRAL]: "Entrée neutre",
};
